import { Controller } from "@hotwired/stimulus"
import { presetRange, setPickerDate } from "../helpers/date_presets"

// Quick picks ("Diese Woche", "Letzte Woche") for a Von–Bis filter
// (Common::FilterFields::DateRangeComponent with `presets:`). They only fill the two
// fields; the filter still applies on "Anwenden" like any other change.
export default class extends Controller {
  static targets = ["from", "to"]

  apply(event) {
    const [from, to] = presetRange(event.currentTarget.dataset.preset, new Date())
    setPickerDate(this.fromTarget, from)
    setPickerDate(this.toTarget, to)
  }
}
